export default __webpack_public_path__ + "static/media/fabric.a20b9166.jpg";